module.exports = __webpack_public_path__ + "static/media/coupon_without_instruction.1104509e.svg";